<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" clearable></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="merchants"
      :search="search"
      :items-per-page.sync="itemPerPage"
      :page.sync="currentPage"
      class="transparent"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:top>
        <v-btn fab absolute bottom @click="edit({ status: 1 })" dark class="pink">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn icon @click="edit(item)">
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.status="{ item }">{{ $t("status.rec_" + item.status) }}</template>
      <template v-slot:item.type="{ item }">{{ $t("merch_type[" + item.type+"].text") }}</template>
      <template v-slot:item.created="{ item }">{{ item.created | dt_time }}</template>
      <template v-slot:item.updated="{ item }">{{ item.updated | dt_time }}</template>
    </v-data-table>
    <v-dialog v-model="d_edit" persistent width="800" height="800">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <i18n path="admin.merchant">
            <template #idx>
              <span>{{item.idx}}</span>
            </template>
          </i18n>
          <v-spacer></v-spacer>
          <v-btn @click="d_edit = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="item.name"
              :error-messages="msg_errors"
              :label="$t('fields.name')"
              :rules="[(v) => !!v || $t('error.required')]"
            ></v-text-field>
            <v-select
              v-model="item.bin"
              :items="$store.getters['admin/bins']"
              item-text="name"
              item-value="bin"
              :label="$t('fields.bin')"
              :rules="[(v) => !!v || $t('error.required')]"
            ></v-select>
            <v-text-field v-model="item.passType" :label="$t('fields.passtype')"></v-text-field>
            <v-select
              v-model="item.type"
              :items="$t('merch_type')"
              :label="$t('fields.merch_type')"
            ></v-select>
            <!-- <v-select
              v-if="item.type==0"
              v-model="item.webSetting.fields"
              :items="fields"
              attach
              chips
              :label="$t('fields.anketa')"
              multiple
            ></v-select>-->
            <v-chip-group multiple active-class="green white--text" v-model="flds">
              <v-chip v-for="tag in fields" :key="tag">{{ tag }}</v-chip>
            </v-chip-group>
            <v-select v-model="item.status" :items="$t('statuses')" :label="$t('fields.status')"></v-select>
          </v-form>
          <div>
            <a :href="link(item)" target="_blank" id="linkUrl">{{ link(item) }}</a>
            <v-btn icon @click="getLinkCopy">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <v-btn icon @click="getQrCode">
              <v-icon>mdi-qrcode</v-icon>
            </v-btn>
            <!-- <canvas id="qrcodecanvas"></canvas> -->
            <img v-show="qrPresent" id="qrcodeimage" alt />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="d_confirm = true" color="primary">{{ $t("button.delete") }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="update" color="primary">{{ $t("button.update") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      v-model="d_confirm"
      :mode="dmode"
      @click:ok="remove"
    >{{ $t("dialog.txt.delMerchant") }}</ConfirmDialog>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import QrCodeWithLogo from "qrcode-with-logos";

export default {
  name: "AdminMerchants",
  mixins: [commonmixin],
  data() {
    return {
      flds: [],
      item: {
        webSetting: {},
      },
      qrPresent: false,
      fields: ["name", "surname", "email", "phone", "additional", "birthday"],
      d_edit: false,
      msg_errors: "",
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          sortable: false,
          align: "left",
        },
        { text: this.$t("fields.name"), value: "name" },
        { text: this.$t("fields.merch_type"), value: "type" },
        { text: this.$t("fields.bin"), value: "bin" },
        { text: this.$t("fields.totalcards"), value: "totalCards" },
        { text: this.$t("fields.freecards"), value: "freeCards" },
        { text: this.$t("fields.status"), value: "status" },
        { text: this.$t("fields.passtype"), value: "passType" },
        { text: this.$t("fields.created"), value: "created", align: "center" },
        { text: this.$t("fields.updated"), value: "updated", align: "center" },
      ],
    };
  },
  computed: {
    merchants() {
      return this.$store.getters["admin/merchants"];
    },
  },
  methods: {
    link(i) {
      return this.$api.api + "/cards/" + i.bin;
    },
    getQrCode() {
      try {
        const linkUrl = this.link(this.item);
        //        console.log(linkUrl);
        const qrCodeLogo = new QrCodeWithLogo({
          //canvas: document.getElementById("qrcodecanvas"),
          content: linkUrl,
          width: 200,
          download: false,
          //          logo:{src: "favicon.png", logoSize: .2, logoRadius: 25, borderRadius: 25},
          logo: { src: "favicon.png" },
          image: document.getElementById("qrcodeimage"),
        });

        qrCodeLogo.toImage().then(() => {
          this.qrPresent = true;
        });
      } catch (error) {
        console.log(error);
        this.qrPresent = false;
      }
    },
    getLinkCopy() {
      try {
        let range = document.createRange();
        range.selectNode(document.getElementById("linkUrl"));
        //console.log(range);
        window.getSelection().removeAllRanges(); // clear current selection
        window.getSelection().addRange(range); // to select text
        document.execCommand("copy");
        window.getSelection().removeAllRanges(); // to deselect
      } catch (error) {
        console.log(error);
      }
    },
    edit(i) {
      this.d_edit = true;
      this.item = { ...i };
      if (!this.item.webSetting) this.item.webSetting = { fields: [] };
      this.flds = this.flds.splice(0, this.flds.length);
      this.item.webSetting.fields.forEach((e) => {
        let ind = this.fields.indexOf(e);
        if (ind != -1) {
          this.flds.push(ind);
        }
      });
      this.currentIdx = this.merchants.indexOf(i);
    },
    remove() {
      this.$store.dispatch("admin/DELETE_MERCHANT", this.item).then(() => {
        this.d_edit = false;
      });
    },
    update() {
      this.item.webSetting.fields = [];
      this.flds.sort().forEach((e) => {
        this.item.webSetting.fields.push(this.fields[e]);
      });
      if (this.item.idx) {
        this.$store
          .dispatch("admin/UPDATE_MERCHANT", {
            item: this.item,
            index: this.currentIdx,
          })
          .then(() => {
            this.d_edit = false;
          });
      } else {
        const prev = this.items.find((e) => {
          return e.name == this.item.name;
        });
        if (prev) {
          this.msg_errors = this.$t("error.dublicate");
        } else {
          this.$store
            .dispatch("admin/INSERT_MERCHANT", this.item)
            .then((response) => {
              if (response == 0) {
                this.msg_errors = this.$t("error.api");
              } else {
                this.d_edit = false;
              }
            });
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch("admin/LOAD_MERCHANTS");
    if (!this.$store.getters["admin/isBins"]) {
      this.$store.dispatch("admin/LOAD_BINS");
    }
  },
};
</script>

<style scoped>
#qrcodeimage {
  height: 200px;
  width: 200px;
}
</style>